if (!customElements.get('page-banner-countdown')) {
  class PageBannerCountdown extends HTMLElement {
    constructor() {
      super();
      this.endDate = this.dataset.endDate;
      this.display = this.querySelector('[data-time-display]');
      this.daysEl = this.querySelector('[data-days]');
      this.hoursEl = this.querySelector('[data-hours]');
      this.minutesEl = this.querySelector('[data-minutes]');
      this.secondsEl = this.querySelector('[data-seconds]');
      this.timerComplete = false;
      this.intervalId = null;
    }

    connectedCallback() {
      if (!this.endDate || !this.display) return;

      this.tick();
      this.intervalId = window.setInterval(() => {
        if (!this.timerComplete) this.tick();
      }, 1000);
    }

    disconnectedCallback() {
      if (this.intervalId) window.clearInterval(this.intervalId);
    }

    tick() {
      const target = Date.parse(this.endDate);
      if (Number.isNaN(target)) return;

      const diff = target - Date.now();

      if (diff > 0) {
        const intervals = {
          days: Math.floor(diff / (1000 * 60 * 60 * 24)),
          hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((diff / 1000 / 60) % 60),
          seconds: Math.floor((diff / 1000) % 60),
        };

        this.setUnit(this.daysEl, intervals.days);
        this.setUnit(this.hoursEl, intervals.hours);
        this.setUnit(this.minutesEl, intervals.minutes);
        this.setUnit(this.secondsEl, intervals.seconds);
        this.display.classList.add('page-banner-countdown__display--loaded');
        return;
      }

      this.setUnit(this.daysEl, 0);
      this.setUnit(this.hoursEl, 0);
      this.setUnit(this.minutesEl, 0);
      this.setUnit(this.secondsEl, 0);
      this.timerComplete = true;

      if (this.intervalId) {
        window.clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }

    setUnit(el, value) {
      if (!el) return;
      el.textContent = String(value).padStart(2, '0');
    }
  }

  customElements.define('page-banner-countdown', PageBannerCountdown);
}

function initPageBannerAnchorScroll(root = document) {
  root.querySelectorAll('.page-banner__button[data-page-banner-anchor]').forEach((button) => {
    if (button.dataset.pageBannerAnchorInit) return;
    button.dataset.pageBannerAnchorInit = 'true';

    button.addEventListener('click', (event) => {
      const hash = button.getAttribute('href');
      if (!hash || hash === '#') return;

      let target = document.querySelector(hash);

      if (!target) {
        const sectionKey = hash.slice(1);
        if (!sectionKey) return;

        target =
          document.getElementById(`shopify-section-${sectionKey}`) ||
          document.querySelector(`[id$="__${sectionKey}"]`);
      }

      if (!target) return;

      event.preventDefault();

      const header = document.querySelector('.site-header');
      const offset = header ? header.offsetHeight : 0;
      const top = target.getBoundingClientRect().top + window.scrollY - offset;

      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    });
  });
}

document.addEventListener('DOMContentLoaded', () => initPageBannerAnchorScroll());
document.addEventListener('shopify:section:load', (event) => initPageBannerAnchorScroll(event.target));
